import React from 'react';

import { PlatformIconProps } from './PlatformIcon.types';

import AmazonFire from '../../../assets/icons/AmazonFire';
import Ipad from '../../../assets/icons/Ipad';

const platforms = {
  ipad: {
    svg: Ipad,
  },
  fire: {
    svg: AmazonFire,
  },
};

const PlatformIcon = ({
  platform,
  size,
  componentClassname = 'platform-icon',
  customClassnames = '',
}: PlatformIconProps) => {
  const platformInfo = platforms[platform];
  if (!platformInfo) {
    return null;
  }

  const SvgComponent = platformInfo.svg;

  return (
    <SvgComponent
      className={`${componentClassname} ${customClassnames}`}
      height={size}
      width={size}
    />
  );
};
PlatformIcon.displayName = 'PlatformIcon';

export default PlatformIcon;
